var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-tag-manager',{attrs:{"service":"origins","title":"Origem","delete-modal-title":"Deseja realmente excluir a(s) origem(s)?"}})
}
var staticRenderFns = []

export { render, staticRenderFns }